import React from 'react'

export const Footer = () => {
    return (
        <section className="footer">
            &copy; <b style={{color:"red"}}>Sandeep</b> All rigths reserved
        </section>
    )
}
